<template>
    <div v-if="LoggingId" style="position: fixed; top: 180px; right: 100px; border: 2px solid #e00000; background: #ffd71a; padding: 20px; z-index: 500;">
        Log Id:
        <br /><br />
        <a :href="detailsLink" target="_blank">{{LoggingId}}</a>
        <br /><br />
        <a href="#" @click.prevent="hide" style="color: black;">hide</a>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'LoggingId'
            ]),
            detailsLink() {
                return "/debug/de/applog/" + this.LoggingId;
            }
        },
        methods: {
            hide() {
                this.$store.commit('setLoggingId', '');
            }
        }
    };
</script>